<agr-page-toolbar
  [pageTitle]="'app.contactperson.navigation.details' | translate"
></agr-page-toolbar>
<section class="spacing--padding-all" data-test="contactperson-detail">
  <form [formGroup]="form" [agrConnectForm]="details$" (ngSubmit)="save()">
    <div class="form-field-wrapper">
      <div class="text--h5">{{ 'app.contactperson.detail.title_general' | translate }}</div>
      @if ((routeUrl$ | async) !== '/contactperson/add') {
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            readonly
            inputmode="numeric"
            placeholder="{{ 'app.contactperson.detail.id' | translate }}"
            formControlName="id"
            data-test="contactperson-detail__id"
          />
        </mat-form-field>
      }

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.first_name' | translate }}"
          formControlName="firstName"
          data-test="contactperson-detail__firstName"
        />
        @if (form.controls.firstName.invalid) {
          <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.last_name' | translate }}"
          formControlName="lastName"
          data-test="contactperson-detail__lastName"
        />
        @if (form.controls.lastName.invalid) {
          <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
        }
      </mat-form-field>

      <div class="text--h5">{{ 'app.contactperson.detail.title_address' | translate }}</div>
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.street' | translate }}"
          formControlName="street"
          data-test="contactperson-detail__street"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.postal_code' | translate }}"
          formControlName="postalCode"
          data-test="contactperson-detail__postal-code"
        />
      </mat-form-field>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            agrNumber
            placeholder="{{ 'app.contactperson.detail.house_number' | translate }}"
            formControlName="houseNumber"
            data-test="contactperson-detail__house-number"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.contactperson.detail.house_number_addition' | translate }}"
            formControlName="houseNumberAddition"
            data-test="contactperson-detail__house-number-addition"
          />
        </mat-form-field>
      </div>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <input
            matInput
            inputmode="text"
            placeholder="{{ 'app.contactperson.detail.city' | translate }}"
            formControlName="city"
            data-test="contactperson-detail__city"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'app.contactperson.detail.country' | translate }}</mat-label>
          <mat-select formControlName="country" data-test="contactperson-detail__country">
            <mat-option>-</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.countryCode">
                {{ 'app.countries.' + country.countryCode | translate }}
              </mat-option>
            }
          </mat-select>
          @if (form.controls.country.invalid) {
            <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="text--h5">{{ 'app.contactperson.detail.title_contact' | translate }}</div>
      <mat-form-field class="flex__child--auto">
        <input
          matInput
          type="email"
          placeholder="{{ 'app.contactperson.detail.email_address' | translate }}"
          formControlName="emailAddress"
          data-test="contactperson-detail__email-address"
        />
        @if (form.controls.emailAddress.errors?.required) {
          <mat-error>{{ 'app.errormsg.mandatory_form_field' | translate }}</mat-error>
        }
        @if (form.controls.emailAddress.errors?.email) {
          <mat-error>{{ 'app.errormsg.email_pattern' | translate }}</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.phone_number' | translate }}"
          formControlName="phoneNumber"
          data-test="contactperson-detail__phone-number"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <input
          matInput
          inputmode="text"
          placeholder="{{ 'app.contactperson.detail.mobile_number' | translate }}"
          formControlName="mobileNumber"
          data-test="contactperson-detail__mobile-number"
        />
      </mat-form-field>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="contactperson-detail__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</section>
